import { __assign, __rest } from 'tslib';
import React__default from 'react';
import { Card } from '../card/Card.js';
import { Heading } from '../heading/Heading.js';
import { Text } from '../text/Text.js';

var defaultStyles = {
  py: 30,
  px: [20, 40],
  display: "block"
};
var alertIntents = {
  default: __assign(__assign({}, defaultStyles), {
    backgroundColor: "white"
  }),
  success: __assign(__assign({}, defaultStyles), {
    backgroundColor: "white"
  }),
  warning: __assign(__assign({}, defaultStyles), {
    backgroundColor: "white"
  }),
  error: __assign(__assign({}, defaultStyles), {
    backgroundColor: "white"
  }),
  info: __assign(__assign({}, defaultStyles), {
    backgroundColor: "white"
  })
};
var headingColorForIntent = {
  default: "text.heading",
  success: "greenLantern",
  warning: "clockwork",
  error: "deal",
  info: "mystique"
};
var messageColorForIntent = {
  default: "text.heading",
  success: "text.heading",
  warning: "text.heading",
  error: "text.heading",
  info: "text.heading"
};
var Alert = function (_a) {
  var label = _a.label,
    message = _a.message,
    _b = _a.intent,
    intent = _b === void 0 ? "default" : _b,
    children = _a.children,
    rest = __rest(_a, ["label", "message", "intent", "children"]);
  var intentStyles = alertIntents[intent];
  return React__default.createElement(Card, __assign({}, defaultStyles, intentStyles, {
    display: "block"
  }, rest), label && React__default.createElement(Heading, {
    as: "p",
    variant: "xxs",
    color: headingColorForIntent[intent]
  }, label), message && React__default.createElement(Text, {
    variant: "sm",
    color: messageColorForIntent[intent]
  }, message), children);
};

export { Alert, alertIntents };
//# sourceMappingURL=Alert.js.map
